// Configuración de correo de la plataforma (superadmin).
// La de cada cliente vive en /clientes/$id → Correo.

import { createFileRoute, redirect } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { configRouteRedirect } from '~/lib/config-access';
import { currentUser } from '~/lib/pb';
import { PlatformMailSettings } from '~/components/ResendSettings/ResendSettings';
import page from './_authed.clientes.module.css';

export const Route = createFileRoute('/_authed/configuracion/correo')({
  beforeLoad: () => {
    const dest = configRouteRedirect(currentUser()?.role, '/configuracion/correo');
    if (dest) throw redirect({ to: '/' });
  },
  component: CorreoPage,
});

function CorreoPage() {
  const me = currentUser();
  if (me?.role !== 'superadmin') {
    return (
      <div className={page.page}>
        <div className={page.notSuperadmin}>
          <ShieldAlert size={32} aria-hidden style={{ marginBottom: 12 }} />
          <p>La configuración de correo es solo para superadmins.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={page.page}>
      <header className="page-header">
        <div className="page-header__titles">
          <h1 className="h2">Correo</h1>
          <p className="page-header__subtitle">
            Cuenta de Resend de la plataforma. Los clientes sin cuenta propia envían por acá. El correo
            de cada cliente se configura en su ficha, pestaña Correo.
          </p>
        </div>
      </header>
      <PlatformMailSettings />
    </div>
  );
}
